var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSingleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.10766 10.2584C6.72183 9.89636 6.11712 9.91732 5.75701 10.3052C5.3969 10.6931 5.41776 11.301 5.80359 11.663L13.348 18.7416C13.7151 19.0861 14.2849 19.0861 14.652 18.7416L22.1964 11.663C22.5822 11.301 22.6031 10.6931 22.243 10.3052C21.8829 9.91732 21.2782 9.89636 20.8923 10.2584L14 16.7252L7.10766 10.2584Z",
    fill: "#005FC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSingleDown);
export default __webpack_public_path__ + "static/media/arrow-single-down.4a41c5b3037dbb5ddd20ef8a892cb07f.svg";
export { ForwardRef as ReactComponent };